module.exports = __webpack_public_path__ + "img/微信图片_20251028123223_206_595.2ab93330.jpg";